<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select
        v-model="listQuery.status"
        :placeholder="$t('table.status')"
        style="width: 100px"
        class="filter-item"
      >
        <el-option label="全部" value="-1"/>
        <el-option v-for="(item,key) in statusType" :key="key" :label="item" :value="key"/>
      </el-select>
      <el-button
        v-waves
        class="filter-item"
        style="margin-left: 10px;"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
      >{{ $t('table.search') }}</el-button>
      <el-button
        class="filter-item"
        style="margin-left: 10px;"
        type="primary"
        icon="el-icon-edit"
        @click="handleCreate"
      >{{ $t('table.add') }}</el-button>
    </div>
    <el-table
      v-loading="listLoading"
      :key="tableKey"
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%"
    >
      <el-table-column :label="$t('table.id')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.payTypeId }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('seting.payTypeName')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.payTypeName }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('grade.status')" align="center" width="100%">
        <template slot-scope="scope">
          <span>{{ scope.row.status | statusFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column label="时间" align="center" width="250%">
        <template slot-scope="scope">
          <span>{{ scope.row.createdTime }}</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('table.actions')"
        align="center"
        width="250%"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.status==0"
            size="mini"
            type="success"
            @click="handleModifyStatus(scope.row)"
          >启用</el-button>
          <el-button v-else size="mini" type="danger" @click="handleModifyStatus(scope.row)">禁用</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" width="450px">
      <el-form
        ref="dataForm"
        :rules="rules"
        :model="temp"
        label-position="right"
        label-width="100px"
        style="margin-right:30px;"
      >
        <el-form-item :label="$t('seting.payTypeName')" prop="payTypeName">
          <el-input v-model="temp.payTypeName" placeholder/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">{{ $t('table.cancel') }}</el-button>
        <el-button type="primary" @click="createData">{{ $t('table.confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listPayType, addPayType, updatePayType } from '@/api/setting'
import waves from '@/directive/waves' // 水波纹指令

const typeOptions = [{ value: 1, label: '总帐支付' }, { value: 2, label: '子账支付' }]
const statusMap = { '0': '禁用', '1': '启用' }
export default {
  name: 'Pay',
  directives: {
    waves
  },
  filters: {
    statusFilter (status) {
      return statusMap[status]
    },
    typeFilter (type) {
      for (const key in typeOptions) {
        if (typeOptions[key].value === type) {
          return typeOptions[key].label
        }
      }
    }
  },
  data () {
    return {
      tableKey: 0,
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
        status: '-1',
        payTypeName: ''
      },
      showReviewer: false,
      temp: {
        payTypeId: undefined,
        payTypeName: ''
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '添加'
      },
      types: typeOptions,
      statusType: statusMap,
      rules: {
        payTypeName: [
          { required: true, message: '必须填写', trigger: 'blur' },
          { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }
          ]
      },
      gradeLists: []
    }
  },
  created () {
    this.getList()
  },
  methods: {
    getList () {
      this.listLoading = true
      this.listQuery['pi'] = this.listQuery.page
      this.listQuery['ps'] = this.listQuery.limit
      listPayType(this.listQuery).then(response => {
        const row = response.data
        if (row.data) {
          this.list = row.data
        }
        this.listLoading = false
      })
    },
    handleFilter () {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange (val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.listQuery.page = val
      this.getList()
    },
    handleModifyStatus (row) {
      // 禁用等级
      if (row.status === 1) {
        this.$confirm('禁用会导致该支付方式不可用, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          let flag = !row.status
          flag = flag ? 1 : 0
          updatePayType({ payTypeId: row.payTypeId, status: flag }).then(res => {
            this.getList()
            this.$message({
              message: '操作成功',
              type: 'success'
            })
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消禁用'
          })
        })
      } else {
        let flag = !row.status
        flag = flag ? 1 : 0
        updatePayType({ payTypeId: row.payTypeId, status: flag }).then(res => {
          this.getList()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
        })
      }
    },
    resetTemp () {
      this.temp = {
        payTypeId: undefined,
        payTypeName: ''
      }
    },
    handleCreate () {
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    createData () {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.listLoading = true
          addPayType(this.temp).then((res) => {
            this.dialogFormVisible = false
            this.listLoading = false
            this.$notify({
              title: '成功',
              message: '创建成功',
              type: 'success',
              duration: 1500
            })
            this.getList()
          }).catch(() => {
            this.dialogFormVisible = false
            this.listLoading = false
          })
        }
      })
    }
  }
}
</script>
